import React from "react";
import "./Sidebar.css"; // 使用同樣的樣式

const HamburgerButton = ({ onClick }) => (
  <button className="hamburger-menu" onClick={onClick}>
    ☰
  </button>
);

export default HamburgerButton;